var _path, _path2, _path3, _path4, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnpin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.959 15.529L12.332 14.902L16.743 7.586L16.805 7.647C17.0697 7.91129 17.4285 8.05961 17.8026 8.05933C18.1766 8.05905 18.5352 7.91019 18.7995 7.6455C19.0638 7.38082 19.2121 7.02198 19.2118 6.64794C19.2115 6.2739 19.0627 5.91529 18.798 5.651L14.759 1.616C14.6297 1.47811 14.4741 1.36761 14.3013 1.29108C14.1285 1.21454 13.942 1.17353 13.7531 1.17047C13.5641 1.16742 13.3764 1.20239 13.2012 1.2733C13.0261 1.34421 12.8669 1.44963 12.7333 1.58327C12.5996 1.71691 12.4942 1.87606 12.4233 2.05125C12.3524 2.22644 12.3174 2.4141 12.3205 2.60307C12.3235 2.79204 12.3645 2.97848 12.4411 3.15128C12.5176 3.32409 12.6281 3.47975 12.766 3.609L12.827 3.671L5.513 8.081L4.883 7.451C4.62329 7.19147 4.27115 7.04569 3.904 7.04569C3.53684 7.04569 3.18471 7.19147 2.925 7.451L2.315 8.06C2.05571 8.31984 1.9101 8.67193 1.9101 9.039C1.9101 9.40608 2.05571 9.75816 2.315 10.018L10.391 18.094C10.6498 18.3545 11.0014 18.5015 11.3685 18.5028C11.7357 18.5041 12.0884 18.3596 12.349 18.101V18.101L12.962 17.488C13.0905 17.3592 13.1923 17.2063 13.2617 17.0382C13.331 16.87 13.3666 16.6898 13.3663 16.5079C13.366 16.326 13.3299 16.1459 13.26 15.9779C13.1901 15.81 13.0879 15.6574 12.959 15.529Z",
    stroke: "#213960",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40099 14.189L1.20099 19.211",
    stroke: "#213960",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51001 8.08002L12.207 14.777",
    stroke: "#213960",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.766 3.60803L16.804 7.64603",
    stroke: "#213960",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.5858,
    y1: 16,
    x2: 4.00001,
    y2: 2.41421,
    stroke: "#213960",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.c224875aa057dc2aef120538afd43f99.svg";
export { ForwardRef as ReactComponent };